import { render } from "./CartItemView.vue?vue&type=template&id=0fe72c99&scoped=true"
import script from "./CartItemView.vue?vue&type=script&lang=js"
export * from "./CartItemView.vue?vue&type=script&lang=js"

import "./CartItemView.vue?vue&type=style&index=0&id=0fe72c99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe72c99"]])

export default __exports__